import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import { TextField } from '@material-ui/core';

import { WithApp } from 'contexts/appContext';

//servicios
import { Toasty, useToasty } from 'hooks/Toasty';
import ListGrouped from './ListGrouped';
import { wsFindBy, wsCreate, wsRemove, wsUpdate } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

export default WithApp(function NewUpdateRole(props) {
  const classes = useStyles();
  const { id } = useParams(0);
  const isCreate = id == 0;
  const [notify, showNotify] = useToasty();
  const searchInpt = useRef(null);

  const [dataRole, setDataRole] = useState('');
  const [permissions, setPermissions] = useState([]);
  const [permissionAsigneds, setPermissionAsigneds] = useState([]);
  const [permissionIds, setpermissionIds] = useState([]);
  const [clear, setClear] = useState(false);

  async function listPermissions(idRole) {
    let response = await wsFindBy('oauth/permissions', { grouped: true, without_rol: idRole });
    if (response.success) {
      setPermissions(response.data);
    }
  }

  async function getRole(idRole) {
    let response = await wsFindBy('oauth/roles/' + idRole, { grouped: true });
    if (response.success) {
      setDataRole(response.data.name);
      setPermissionAsigneds(response.data.permissions);
    }
  }

  async function asignedPermission(checkeds) {
    if (checkeds.length < 1 && !isCreate) {
      showNotify('Selecciona almenos un permiso', 'info');
      return;
    }
    let response = await wsCreate('oauth/authorizations/attach-permission-to-role', {
      permission_id: checkeds,
      role_id: id
    });
    if (response.success) {
      showNotify(response.message);
      getRole(id);
      listPermissions(id);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function removePermission(checkeds) {
    if (checkeds.length < 1) {
      showNotify('Selecciona almenos un permiso', 'info');
      return;
    }
    let response = await wsRemove('oauth/authorizations/revoke-permission-from-role', {
      permission_id: checkeds,
      role_id: id
    });
    if (response.success) {
      showNotify(response.message);
      getRole(id);
      listPermissions(id);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function NewUpdateRole() {
    let datainput = searchInpt.current.querySelector('input').value;
    let response;
    if (isCreate) {
      response = await wsCreate('oauth/roles', { name: datainput, permissions: permissionIds });
    } else {
      response = await wsUpdate('oauth/roles', id, { name: datainput });
    }
    if (response.success) {
      showNotify(response.message);
      if (isCreate) {
        setClear(!clear);
        setPermissions([...permissions]);
      }
    } else {
      showNotify(response.message, 'error');
    }
  }

  function getPermissionCheckeds(checkeds) {
    setpermissionIds(checkeds);
  }

  useEffect(() => {
    listPermissions(id);
    if (!isCreate) {
      getRole(id);
    }
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <GridItem xs={5}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Datos generales</h4>
          </CardHeader>

          <CardBody>
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                NewUpdateRole();
              }}
            >
              <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <TextField
                  key={dataRole + clear}
                  ref={searchInpt}
                  label="Nombre del rol"
                  name="name"
                  margin="normal"
                  fullWidth={true}
                  defaultValue={dataRole || ''}
                />
                <Button
                  color={props.themeContext.buttonColorSuccess}
                  size="sm"
                  type="submit"
                  style={{ marginLeft: '25px' }}
                >
                  Guardar
                </Button>
              </div>
            </form>
            <hr />
            {id == 0 ? undefined : (
              <ListGrouped
                data={permissionAsigneds}
                getCheckbox={removePermission}
                buttonText="Remover"
                buttonColor="danger"
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={7}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de todos los permisos</h4>
          </CardHeader>
          <CardBody key={clear}>
            <ListGrouped
              data={permissions}
              getCheckbox={asignedPermission}
              buttonText="Agregar"
              buttonColor="warn"
              getPermissionCheckeds={isCreate ? getPermissionCheckeds : undefined}
              buttonHide={isCreate ? true : false}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
